module.exports = __webpack_public_path__ + "static/media/LeftNav_Icon_Courses.3a210849.svg";